import { map, find } from "lodash"
import { getInstrumentTypeCharacter } from "helpers/metrics/utils"
import { DELTA_SYMBOL } from "helpers/assets/constants"
import { RULES } from "connected-components/compare/position-sets"
import { getExcelValue } from "helpers/csv"

export function handleGenerateHeaders(instrumentsWithMetadata, positionSetsMetadata, firstColumnLabel, isEndVsStartDateComparison) {
  if (instrumentsWithMetadata) {
    const isCompareWeightStrategy = instrumentsWithMetadata?.comparison?.type === RULES
    const matchedKeys = {}
    const instrumentNames = map(positionSetsMetadata, (positionSet) => {
      let instrumentType = null
      let instrument = find(instrumentsWithMetadata, ({ id, experimentId }, key) => {
        const isMatch = positionSet.experimentId ? experimentId === positionSet.experimentId : id === positionSet.id
        // In end vs start comparison, the comparison instrument is identical to the original instrument,
        // so matching only by id is not enough. We need to make sure we match with the original instrument once
        // and the comparison instrument once so the key/instrumentType is unique. To do this, we keep track of
        // the keys we've already matched and only match if the key hasn't been matched yet.
        if (isMatch && !matchedKeys[key]) {
          matchedKeys[key] = true
          instrumentType = key
          return true
        }
        return false
      })

      if (!instrument && positionSet.dates && instrumentsWithMetadata.rebalanced) {
        instrument = instrumentsWithMetadata.rebalanced
        instrumentType = "rebalanced"
      }

      if (isCompareWeightStrategy && instrumentType === "comparison") {
        return "Selection"
      }

      const instrumentTypeCharacter = getInstrumentTypeCharacter(instrumentType, isEndVsStartDateComparison, isCompareWeightStrategy, instrumentsWithMetadata[instrumentType]?.isOptimization)
      return instrumentTypeCharacter ? `${instrumentTypeCharacter}: ${instrument?.name}` : instrument?.name
    })
    const deltaHeader = isCompareWeightStrategy ? "Sizing" : DELTA_SYMBOL
    return [firstColumnLabel, ...instrumentNames, ...(instrumentNames.length > 1 ? [deltaHeader] : [])]
  }
  return [firstColumnLabel, ...map(positionSetsMetadata, "name")]
}

export function handleGenerateRows(rows, formatter, currency) {
  return rows.map(({ label, values, formatter: itemFormatter, isCurrency }) => {
    const rowLabel = isCurrency && currency ? `${label} (${currency})` : label
    return [rowLabel, ...map(values, (value) => {
      if (value == null) {
        return value
      }
      if (isCurrency) {
        return getExcelValue(value, { currency: true })
      }
      return (itemFormatter ?? formatter)(value)
    })]
  })
}
